module.exports = __webpack_public_path__ + "static/media/otimizacao-de-processos-icon.f96e52e1.png";